import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

  const [DtDetTable, setDtDetTable, DtDetTableRef]=useStateRef([]);
  let DetTable=[];
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("MetalReceipt_Action")=="Add")
   {
	    setSaveButtonText("Save");
      document.getElementById("optGold").checked=true;
      document.getElementById("optSmith").checked=true;
     
    document.getElementById("txtRecNo").value="{Auto}";
    document.getElementById("txtRecDate").value=(new Date()).toISOString().substring(0,10);
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("MetalReceipt_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("MetalReceipt_EditId"));
   }
   else if(sessionStorage.getItem("MetalReceipt_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("MetalReceipt_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  getMetalName();
  }


  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
   const TMhandleShow1 = () => setTMShow1(true);
    

   const [isDisabled, setisDisabled]=useState(false);

  
  const [DtParty, setDtParty]=useState([]);
  const [DtRecType, setDtRecType]=useState([]);
  const [DtOrderNo, setDtOrderNo]=useState([]);
  const [DtMetal, setDtMetal]=useState([]);
  const [DtMetalCatRec, setDtMetalCatRec]=useState([]);
 

  const [AccCode, setAccCode, AccCodeRef] = useStateRef();
  const [OrderNo, setOrderNo, OrderNoRef] = useStateRef();
 
  const [RecType, setRecType, RecTypeRef] = useStateRef();
  const [MetalCatRec, setMetalCatRec, MetalCatRecRef] = useStateRef();
  const [MetalName, setMetalName, MetalNameRef] = useStateRef();
 
 

  async function TagPrint()
  {
    try
    {
     
      let postData = {
        TagId: document.getElementById("txtRecNo").value
    }
  
    
  
    const results = await apiService.postCall("metalreceipt/tagprint",postData);
  
  
   if (results != "-1") {
  
   }
  }
  
  catch (error) {
    console.log(error);
  }
  }
  

 async function gridAdd () {


      let slno=document.getElementById("txtId").value;
      let MetalName=MetalNameRef.current;
      let MetalCatRec=MetalCatRecRef.current;
      let Purity=document.getElementById("txtPurity").value;
      let Weight=parseFloat(document.getElementById("txtWt").value);
      let TWeight=document.getElementById("txtTotalWt").value;
      let Touch=document.getElementById("txtTouch").value;
      let PureWt=document.getElementById("txtPureWt").value;


      Weight = (isNaN(Weight) === true ? "0" : Weight);

      document.getElementById("txtWt").value=Weight;

      


if ((MetalName.length>0)&&(MetalCatRec.length>0)&&(Weight>0))

{
        DetTable=DtDetTable;


        var cnt = 0;
        try
        {
            cnt = DetTable.length;
           
        }
        catch(err)
        {
            cnt=0;
        }
    
  

        var found = false;
        var i=0;

        for (i = 0; i < cnt; i++) {



            if (DetTable[i].ID == slno) {

                DetTable[i].MetalName = MetalName;
                DetTable[i].MetalCatRec = MetalCatRec;
                DetTable[i].Purity = Purity;
                DetTable[i].Weight = Weight.toFixed(3);
                DetTable[i].TWeight = TWeight;
                DetTable[i].Touch = Touch;
                DetTable[i].PureWt = PureWt;
               
                //det text box clear

              Clear();


                found = true;
                break;
            }
            else {


                if ((DetTable[i].MetalName == MetalName) && (DetTable[i].MetalCatRec == MetalCatRec) && (parseFloat(DetTable[i].Weight).toFixed(3) == parseFloat(Weight).toFixed(3))) {
                    swal({
					  title: "",
					  text: "Already Found",
					  icon: "info",
					  button: "Ok"

						});
	
                    found = true;
                    break;

                }
            }
        }


        if (found == false) {

            var row = {
                "ID": parseInt(cnt) + 1
                , "MetalName": MetalName
                , "MetalCatRec": MetalCatRec
                , "Purity": Purity
                , "Weight": Weight.toFixed(3)
                , "TWeight": TWeight
                , "Touch": Touch
                , "PureWt": PureWt
            };

                DetTable[cnt] = row;

             Clear();
            

             //Calc();

               

        }
      
      await setDtDetTable(DetTable);


 


      //alert(JSON.stringify(DtDetTable));

     Calc();
	 
	 TotalCalc();
}
else
{
	
	swal({
      title: "",
      text: "Fill All Data",
      icon: "info",
      button: "Ok"

    });
	
	
  //alert("Fill All Data");
}

    }

  async function Clear()
   {
            document.getElementById("txtId").value="0";
            setMetalName("");
             await getMetalCatRec();
            setMetalCatRec("");

             document.getElementById("txtPurity").value="";
             document.getElementById("txtWt").value="";
             document.getElementById("txtTouch").value="";
             document.getElementById("txtTotalWt").value="";
             document.getElementById("txtPureWt").value="";

		handleClose1();
		
   }
 function gridRemove (id) {

  
      
      DetTable=DtDetTable;
       
        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;

        for (i = 0; i < cnt; i++)
        {
            if (DetTable[i].ID == id)
            {
                DetTable.splice(i, 1);
                break;
            }
        }

			setDtDetTable(DetTable);
      
			setMetalCatRec("");
			
			TotalCalc();
			
      //Clear();

    }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}

async function TotalCalc () {

      DetTable=DtDetTable;
       
        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
        
        
      let i=0;
		document.getElementById("txtTWt").value="";
		document.getElementById("txtTTWt").value="";
		document.getElementById("txtTPureWt").value="";

        for (i = 0; i < cnt; i++)
        {
            document.getElementById("txtTWt").value=(val(document.getElementById("txtTWt").value)+val(DetTable[i].Weight)).toFixed(3);
			document.getElementById("txtTTWt").value=(val(document.getElementById("txtTTWt").value)+val(DetTable[i].TWeight)).toFixed(3);
			document.getElementById("txtTPureWt").value=(val(document.getElementById("txtTPureWt").value)+val(DetTable[i].PureWt)).toFixed(3);
			
        }

       
      
		
    }

 async function gridEdit (id) {

        await handleShow1();

        DetTable=DtDetTable;

        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }

    
	 
	
	 
        let i=0;

        for (i = 0; i < cnt; i++) {
            if (DetTable[i].ID == id) {

                document.getElementById("txtId").value = id;
			          setMetalName(DetTable[i].MetalName);
                 await getMetalCatRec();
                setMetalCatRec(DetTable[i].MetalCatRec);

                document.getElementById("txtPurity").value = DetTable[i].Purity;
                document.getElementById("txtWt").value = DetTable[i].Weight;
                document.getElementById("txtTotalWt").value = DetTable[i].TWeight;
                document.getElementById("txtTouch").value = DetTable[i].Touch;
                document.getElementById("txtPureWt").value = DetTable[i].PureWt;
               
                break;

            }

          
            
        }



  setDtDetTable(DetTable);
      
	

    }

function Calc()
{
  document.getElementById("txtTotalWt").value=parseFloat(document.getElementById("txtWt").value).toFixed(3);
  document.getElementById("txtPureWt").value=(parseFloat(document.getElementById("txtWt").value)*parseFloat(document.getElementById("txtTouch").value)/100).toFixed(3);

  document.getElementById("txtTotalWt").value=(document.getElementById("txtTotalWt").value==="NaN" ? "0" :document.getElementById("txtTotalWt").value );
  document.getElementById("txtPureWt").value=(document.getElementById("txtPureWt").value==="NaN" ? "0" :document.getElementById("txtPureWt").value );


}

async function ControlSettings()
{

  document.getElementById("txtRecNo").disabled ='true';
  document.getElementById("txtRecDate").disabled ='true';
  
  
  if((sessionStorage.getItem("MetalReceipt_Action")=="Edit") || (sessionStorage.getItem("MetalReceipt_Action")=="Delete"))
   {
  

    document.getElementById("optSmith").disabled ='true';
    document.getElementById("optDealer").disabled ='true';
    document.getElementById("optOthers").disabled ='true';

    document.getElementById("optGold").disabled ='true';
    document.getElementById("optSilver").disabled ='true';
    document.getElementById("optDiamond").disabled ='true';
    document.getElementById("optOthers1").disabled ='true';

    setisDisabled('true');
    
    document.getElementById("txtOrderNo").disabled ='true';
    document.getElementById("txtRecType").disabled ='true';


   }

 



}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("metalreceipt/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let DetailData=results.data.Detail;

  if(HeadData[0][0].OrderType=="SMITH")
  {
    document.getElementById("optSmith").checked=true;
  }
  else if(HeadData[0][0].OrderType=="DEALER")
  {
    document.getElementById("optDealer").checked=true;
  }
  else if(HeadData[0][0].OrderType=="OTHERS")
  {
    document.getElementById("optOthers").checked=true;
  }


  if(HeadData[0][0].MetalType=="GOLD")
  {
    document.getElementById("optGold").checked=true;
  }
  else if(HeadData[0][0].MetalType=="SILVER")
  {
    document.getElementById("optSilver").checked=true;
  }
  else if(HeadData[0][0].MetalType=="DIAMOND")
  {
    document.getElementById("optDiamond").checked=true;
  }
  else if(HeadData[0][0].MetalType=="OTHERS")
  {
    document.getElementById("optOthers1").checked=true;
  }

   await getLookup();
  
  
   await getMetalName();



   document.getElementById("txtRecNo").value =HeadData[0][0].GrnNo;
   document.getElementById("txtRecDate").value=HeadData[0][0].GrnDate.substring(0,10);
   setAccCode(HeadData[0][0].AccCode);
   setOrderNo(HeadData[0][0].CustOrderNo);
   document.getElementById("txtPktNo").value=HeadData[0][0].PocketNo;
   document.getElementById("txtRecType").value=HeadData[0][0].RecType;
   document.getElementById("txtRemarks").value=HeadData[0][0].Remarks;

   DetTable=DetailData[0];

 
   var cnt = 0;
   try {
       cnt = DetTable.length;
   }
   catch (err) {
       cnt = 0;
   }

   
   
 let i=0;
document.getElementById("txtTWt").value="";
document.getElementById("txtTTWt").value="";
document.getElementById("txtTPureWt").value="";

   for (i = 0; i < cnt; i++)
   {
       document.getElementById("txtTWt").value=(val(document.getElementById("txtTWt").value)+val(DetTable[i].Weight)).toFixed(3);
 document.getElementById("txtTTWt").value=(val(document.getElementById("txtTTWt").value)+val(DetTable[i].TWeight)).toFixed(3);
 document.getElementById("txtTPureWt").value=(val(document.getElementById("txtTPureWt").value)+val(DetTable[i].PureWt)).toFixed(3);
 
   }
   
   setDtDetTable(DetTable);



   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
if (DtDetTable.length==0)
{
	swal({

      title: "",
      text: "Please Enter Details",
      icon: "info",
      button: "Ok"

    });
	
	return;
}	
			
			
			
		const optary = document.getElementsByName("group_partytype");
		 let optpartytype="";
		 let i;
		 
		 for(i=0;i<optary.length;i++)
		 {
			 if(optary[i].checked==true)
			 {
				  optpartytype=optary[i].value;
			 }
		 }
		 
		 
	const optary1 = document.getElementsByName("group_metaltype");
     let optmetaltype="";
    
     for(i=0;i<optary1.length;i++)
     {
       if(optary1[i].checked==true)
       {
          optmetaltype=optary1[i].value;
       }
     }
		 
		let postData = {
			"Action" : sessionStorage.getItem("MetalReceipt_Action"),
			"EditId" : sessionStorage.getItem("MetalReceipt_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"RecDate": document.getElementById("txtRecDate").value,
			"AccCode": AccCodeRef.current,
			"PartyType": optpartytype,
			"MetalType": optmetaltype,
			"OrderNo": document.getElementById("txtOrderNo").value,
			"PktNo": document.getElementById("txtPktNo").value,
			"RecType": document.getElementById("txtRecType").value,
			"Remarks": document.getElementById("txtRemarks").value,
			"TWeight": document.getElementById("txtTWt").value,
			"TTotalWt": document.getElementById("txtTTWt").value,
			"TPureWt": document.getElementById("txtTPureWt").value,
			"DetTable1": DtDetTable
		}

   const results = await apiService.postCall("metalreceipt/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("MetalReceipt_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToMetalReceipt();
    });
	
  }

  else if(sessionStorage.getItem("MetalReceipt_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToMetalReceipt();
    });
	
  }
	 
  else if(sessionStorage.getItem("MetalReceipt_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToMetalReceipt();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }



  async function getOrderByParty(){
	  try
    {

      let AccCode=AccCodeRef.current;

     
      let postData = {
        AccCode: AccCode
    }

    const results = await apiService.postCall("metalreceipt/MetalReceiptGetOrderNo",postData);

   if (results != "-1") {
      setDtOrderNo(results.data[0]);
      }
    }
    catch (error) {
      console.log(error);
    }

  }


  async function getMetalName(){
    try
    {

     
    const optary = document.getElementsByName("group_metaltype");
     let optmetaltype="";
     let i;
     
     for(i=0;i<optary.length;i++)
     {
       if(optary[i].checked==true)
       {
          optmetaltype=optary[i].value;
       }
     }
     
    let postData = {
        optmetaltype: optmetaltype
    }

  
      
DetTable=DtDetTable;
DetTable=[];
await setDtDetTable(DetTable);

TotalCalc();


setMetalName("");


    const results = await apiService.postCall("metalreceipt/MetalReceiptGetMetalType",postData);

   if (results != "-1") {
      setDtMetal(results.data[0]);
      }
    }
    catch (error) {
      console.log(error);
    }

  }

   async function getMetalCatRec(){
    try
    {

   
     let MetalName=MetalNameRef.current;
     
      
     
  
     let postData = {
        MetalName: MetalName
    }
     
    const results = await apiService.postCall("metalreceipt/MetalReceiptGetMetalCatRec",postData);

   if (results != "-1") {
      setDtMetalCatRec(results.data[0]);

       document.getElementById("txtPurity").value="91.6"
       document.getElementById("txtTouch").value="100";
      }
    }
    catch (error) {
      console.log(error);
    }

  }



  async function getLookup(){
	 try {
		const optary = document.getElementsByName("group_partytype");
		 let optpartytype="";
		 let i;
		 
		 for(i=0;i<optary.length;i++)
		 {
			 if(optary[i].checked==true)
			 {
				  optpartytype=optary[i].value;
			 }
		 }
		 
		 
		let postData = {
        optpartytype: optpartytype
		}
		
		let rectype=[
		{"RecType":"Direct Purchase(Cash)"},
		{"RecType":"Other Receipt"}
		];
		
		setDtRecType(rectype);


    const results = await apiService.postCall("metalreceipt/MetalReceiptLookup",postData);

	 if (results != "-1") {
			setDtParty(results.data[0]);
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToMetalReceipt = () => {
    navigate('../dashboard/table/smith/metalreceipt/list');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Metal Receipt Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input id="optGold" onChange={getMetalName} value="GOLD"  name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>GOLD</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="SILVER" id="optSilver" onChange={getMetalName} name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>SILVER</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input hidden="hidden" value="DIAMOND" id="optDiamond" onChange={getMetalName} name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label hidden="hidden">DIAMOND</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input hidden="hidden" value="OTHERS" id="optOthers1" onChange={getMetalName} name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label hidden="hidden">OTHERS</Form.Check.Label>
                        </div>
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Rec No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtRecNo" placeholder="" />
                          </div>
						  
						  
						          <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtRecDate" placeholder="" />
                          </div>
						  
						  
                          <div className='col-md-12'>
                            <Form.Label>Party Name</Form.Label>

                            <Select className="form-select-search" id="txtPartyName" 
                             options={DtParty}
                             isDisabled={isDisabled}
                             value={DtParty.filter(function(option) {
                              return option.value === AccCode;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setAccCode(e.value);
                                 getOrderByParty();
                              }
                              }
                             >
              								
							               </Select>

                            
                          </div>
                        </div>

                        <div className='col-md-12 py-2'>
                            <Form.Label>Remark</Form.Label>
                            <Form.Control type="text" id="txtRemarks" placeholder="" />
                          </div>
                          
                        <div className='col-md-12 py-2' hidden='hidden'>
                          <Form.Label>Rec Type</Form.Label>
                           <select className="form-select" id="txtRecType" value={RecType} disabled={false}>
            								{ 
            								DtRecType.map(
            								(item)=>(
            								<option value={item.RecType}>{item.RecType}</option>
            								)
            								)
            								}
							             </select>
                        </div>
                        
                      </div>

                    </div>

                  </div>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input value="SMITH" id="optSmith" name="group_partytype" type="radio" className='me-2' onChange={getLookup} />
                          <Form.Check.Label>SMITH</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="DEALER"  id="optDealer"  name="group_partytype" type="radio" className='me-2' onChange={getLookup} />
                          <Form.Check.Label>DEALER</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="OTHERS"  id="optOthers" hidden="hidden"  name="group_partytype" type="radio" className='me-2' onChange={getLookup} />
                          <Form.Check.Label hidden="hidden">OTHER</Form.Check.Label>
                        </div>
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row '>
                          <div className='row py-2'>
                            <div className='col-md-6' hidden='hidden'>
                              <Form.Label >Order No</Form.Label>
                             <select className="form-select" id="txtOrderNo" disabled={false} value={OrderNo}>
                              { 
                              DtOrderNo.map(
                              (item)=>(
                              <option value={item.OrderNo}>{item.OrderNo}</option>
                              )
                              )
                              }
                             </select>
                            </div>
                            <div className='col-md-6' hidden='hidden'>
                              <Form.Label >Pocket No</Form.Label>
                              <Form.Control type="text" id="txtPktNo" placeholder="" />
                            </div>
                          </div>
                        

                        
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-2 '>
                    <Form.Label>Weight</Form.Label>
                    <Form.Control type="text" id="txtTWt" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div>
                  <div className='col-md-2 '>
                    <Form.Label>Total Wt</Form.Label>
                    <Form.Control type="text" id="txtTTWt" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div>
                  <div className='col-md-2 '>
                    <Form.Label>Pure Wt</Form.Label>
                    <Form.Control type="text" id="txtTPureWt" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div>                             
                </div>
              </div>
			  
			  
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg" >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					</Form.Group>
					 </Modal.Body>
                 </Modal>
				
				
			  
			  <Modal show={show1} onHide={handleClose1} className=".modal-lg" >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-12'>
                              <Form.Label>Metal</Form.Label>

                              <Select className="form-select-search" id="txtMetalName" 
                             options={DtMetal}
                             value={DtMetal.filter(function(option) {
                              return option.value === MetalName;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setMetalName(e.value);
                                 getMetalCatRec();
                              }
                              }
                             >
              								
							               </Select>


                             
                            </div>
                    


                     <div className='col-md-12'>
                              <Form.Label>Metal Catergory Rec</Form.Label>

                              <Select className="form-select-search" id="txtMetalCatRec" 
                             options={DtMetalCatRec}
                             value={DtMetalCatRec.filter(function(option) {
                              return option.value === MetalCatRec;
                            })}
                            onChange=
                            {
                              (e) => {
                                setMetalCatRec(e.value);
                              }
                              }
                             >
              								
							               </Select>

                            </div>
                
                        <div className='col-md-4'>
                              <Form.Label>Purity</Form.Label>
                            <Form.Control type="text" id="txtPurity"  Readonly="Readonly" placeholder="" className="txtReadOnly" />
                            </div>

                              <div className='col-md-4'>
                              <Form.Label>Weight</Form.Label>
                            <Form.Control type="text" id="txtWt" onKeyUp={Calc}    placeholder="" />
                            </div>
                            <div className='col-md-4'>
                              <Form.Label>T.Weight</Form.Label>
                            <Form.Control type="text" id="txtTotalWt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-4'>
                              <Form.Label>Touch</Form.Label>
                            <Form.Control type="text" id="txtTouch" onKeyUp={Calc}  placeholder="" />
                            </div>
                            <div className='col-md-4'>
                              <Form.Label>Pure Wt</Form.Label>
                            <Form.Control type="text" id="txtPureWt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={gridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={Clear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
			  

                  
              <div className="table-responsive mt-4" >
			 
				
                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                    <th>Edit</th>
                      <th>Metal</th>
                      <th>Catergory Rec</th>
                      <th>Purity</th>                 
                      <th>Weight</th>
                      <th>TotalWt</th>
                      <th>Touch</th>
                      <th>PureWt</th>  
                      
						<th>Delete</th>					  
                    </tr>
                  </thead>
                  <tbody>
                  {DtDetTable.map((item) => (
                    <tr>
                       <td>
					   <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>gridEdit(item.ID)} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
						</td>
		
                      <td>{item.MetalName}</td>
                      <td>{item.MetalCatRec}</td>
                      <td>{item.Purity}</td>
                      <td>{item.Weight}</td>
                      <td>{item.TWeight}</td>
                      <td>{item.Touch}</td>
                      <td>{item.PureWt}</td>         
                      
		<td>
					 <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>gridRemove(item.ID)}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
					</td>
                    </tr>
                      )
                      )
                       }     
                  </tbody>
                </Table>
				<div className="EntryPan">
				 <Button type="button" className="detbutton text-center btn-primary btn-icon btn-sm mt-lg-0  mt-md-0 mt-3 " id="cmdDetAdd"  variant="btn btn-primary" onClick={handleShow1}>
			  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
				  </Button>
				</div>
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary'  onClick={TagPrint} >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToMetalReceipt}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
